// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sliderWrapper":"_1to4Y","categoryList":"_3-EER","categoryPlus":"_1-mgN","categoryMenu":"_1xRC4"};